import i18n, { defaultLang } from '@src/i18n';
import { IUser } from '@src/shared/context/current-user';
import { getCurrentPageUrl, isPWA } from '@src/shared/utils';
import { TRACKING_DEFAULTS } from '@src/tracking/constant';
import { OS_TYPES, PAGE_TYPE } from '..';
import { useEffect } from 'react';
import { trackScrollToBottom as trackScrollToBottomCourier, trackAPPLink, trackPageView } from '../tracking/courieroverview/page';
import { trackScrollToBottom as trackScrollToBottomManager } from '../tracking/productoverview/page';
import { useAnalyticsHook } from '@src/tracking/hooks/use-analytics';
interface hookArgs {
  restaurant: IUser | null;
  pageType: PAGE_TYPE;
}

const useOverviewAnalytics = ({ restaurant, pageType }: hookArgs) => {
  const { trackPage, getConsentData } = useAnalyticsHook();
  const trackingArguments = {
    country: restaurant?.country || '',
    language: i18n.language || defaultLang
  } 
  const trackManagerInitialLoad = () => {
    if (getConsentData()) {
      trackPage(TRACKING_DEFAULTS.PAGES_TYPE.DEFAULT, {
        cookieConsent: getConsentData() || '',
        pageGroup: TRACKING_DEFAULTS.PAGES_GROUP.OVERVIEW,
        siteType: TRACKING_DEFAULTS.SITETYPE,
        url: getCurrentPageUrl(),
        country: restaurant?.country as string,
        language: i18n.language || defaultLang,
        restaurantId: restaurant?.id || '',
        pagePWA: JSON.stringify(isPWA()),
      });
    }
  };

  const trackCourierInitialLoad = () => {
    if (getConsentData()) {
      trackPageView(trackingArguments);
    }
  };

  const trackAPPDownload = (osType : OS_TYPES) => {
    trackAPPLink(trackingArguments, osType)
  }

  
  useEffect(() => {
    if (pageType === PAGE_TYPE.MANAGER) {
      trackManagerInitialLoad();
    } else if (pageType === PAGE_TYPE.COURIER) {
      trackCourierInitialLoad();
    }
  }, [getConsentData(), pageType]);

  useEffect(() => {
    function scrollLimitChecker() {
      if (window.innerHeight + window.scrollY >= document.body.scrollHeight) {
        if (pageType === PAGE_TYPE.MANAGER) {
          trackScrollToBottomManager();
        } else if (pageType === PAGE_TYPE.COURIER) {
          trackScrollToBottomCourier();
        }
      }
    }
      window.addEventListener('scroll', scrollLimitChecker);
    return () => {
      window.removeEventListener('scroll', scrollLimitChecker);
    };
  }, [pageType]);
  return {
    trackAPPDownload
  }
};
export default useOverviewAnalytics;
